module.exports = __webpack_public_path__ + "img/logo.9bff1367.png";